<template>
    <div>
        <el-row :gutter="30">
            <el-col :span="6" class="sidebar">
                <ListFilterComponent @setFilter="setFilter"
                                     :allowDeselect="false"
                                     :selectedFilters="filters.selected"
                                     :listFilters="filters.available">
                </ListFilterComponent>
            </el-col>
            <el-col class="box" :span="18">
                <div class="list__header">
                    <p class="list__title">
                        {{ getRouteName($route) }}
                        <br>
                        <small>Złap i przeciągnij</small>
                        <el-button type="warning" @click="sortAlphabetically" class="alphabetically-sort-button">
                            <i class="fa fa-sort-alpha-asc"></i> Przesortuj alfabetycznie
                        </el-button>
                    </p>
                </div>
                <el-card class="box-card new-order-box" :class="{'new-order-box--visible': newOrder}">
                    <p>Kolejność została zmieniona</p>
                    <el-button @click="submitOrder">Zapisz nową kolejność</el-button>
                </el-card>
                <ul class="list" v-loading="listLoading">
                    <draggable v-model="data" :options="{}" @start="drag=true" @end="orderChanged">
                        <transition-group>
                            <li v-for="item in data" :key="item.id" class="item">
                                <span class="item__name">{{ item.name_pl }}</span>
                                <span class="item__icon"><i class="fa fa-align-justify"></i></span>
                            </li>
                        </transition-group>
                    </draggable>
                </ul>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import {Concert, Spectacle, Film, OtherEvent} from '@/api/';
    import ListFilterComponent from '@/components/ListFilterComponent'
    import draggable from 'vuedraggable'

    export default {
        data () {
            return {
                filters: {
                    available: [
                        {
                            name: this.$i18n.t('year'),
                            query_param: 'edition',
                            options: []
                        }
                    ],
                    selected: {}
                },
                data: [],
                newOrder: false,
                listLoading: false,
                service: null
            }
        },
        methods: {
            getService () {
                const type = this.$route.meta.eventType
                const services = {
                    'theater': Spectacle,
                    'music': Concert,
                    'others': OtherEvent,
                    'cinema': Film
                }
                return services[type]
            },
            submitOrder () {
                const order = this.data.map(item => item.id)
                const payload = {
                    'edition': this.filters.selected.edition,
                    'order[]': order
                }
                this.service.changeOrder(payload).then(response => {
                    this.newOrder = false
                    this.$message({
                        message: 'Kolejność została zapisana',
                        type: 'success'
                    })
                    this.fetchData()
                })
            },
            setFilter (filter) {
                const key = filter.query_param
                const value = filter.value
                this.$set(this.filters.selected, key, value)
                this.fetchData()
            },
            orderChanged () {
                this.newOrder = true
                this.drag = false
            },
            updateEditions () {
                const value = this.$store.state.editions
                let options = value.map(edition => {
                    return {label: edition.year, value: edition.id, defaultSelected: edition.current}
                })
                const defaultFilter = options.find(option => option.defaultSelected)
                this.setFilter({
                    query_param: 'edition',
                    value: defaultFilter.value
                })
                this.$set(this.filters.available[0], 'options', options)
            },
            fetchData () {
                let params = {
                    page: this.page,
                    ...this.filters.selected
                };
                this.listLoading = true;
                this.service.getOrder({params}).then(response => {
                    this.data = response.data;
                    this.listLoading = false;
                })
            },
            sortAlphabetically () {
                const sortFn = (a, b) => {
                    if (a.name_pl === a.name_en) {
                        return 0
                    }

                    return a.name_pl > b.name_pl ? 1 : -1
                }
                this.data.sort(sortFn)
                this.newOrder = true
            }
        },
        beforeMount () {
            this.service = this.getService()
        },
        mounted () {
            this.$store.dispatch('fetchEditions').then(response => {
                this.updateEditions()
            })
        },
        components: {
            ListFilterComponent,
            draggable
        }
    }
</script>
<style lang="scss" scoped>
    .list {
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    .item {
        display: flex;
        justify-content: space-between;
        padding: 8px 5px;
        cursor: pointer;
        &:hover {
            background: #f5f7fa;
        }
        &__name {

        }
        &__icon {

        }
    }

    .new-order-box {
        margin-bottom: 20px;
        max-height: 0;
        background: #e6a23c;
        color: #ffffff;
        transition: max-height 0.15s ease-out;
        overflow: hidden;
        &--visible {
            max-height: 150px;
            transition: max-height 0.25s ease-in;
        }
    }

    .alphabetically-sort-button {
        position: absolute;
        right: 13px;
        top: 20px;
    }
</style>



// WEBPACK FOOTER //
// EventsOrder.vue?993e547c